import React from 'react';
import { useSelector } from 'react-redux';

import { getCheckSheetReportIsOpen } from 'src/module/checkSheet/selector';
import type { FieldReportTypeDef } from './fieldReportTypes';

/** Every report modal takes the same four props, which is what lets one loop render them all. */
export type ReportModalProps = {
  open: boolean;
  reportId: string | null;
  deviceId: string | null;
  handleClose: () => void;
};

type SelectionProps = {
  selectedType: string | null;
  reportId: string | null;
  deviceId: string | null;
  onClose: (type: string) => void;
};

function ReportModal ({ type, Modal, selectedType, reportId, deviceId, onClose }: SelectionProps & {
  type: string;
  Modal: React.ComponentType<ReportModalProps>;
}) {
  const isOpen = useSelector(getCheckSheetReportIsOpen(type));
  return (
    <Modal
      open={isOpen && selectedType === type}
      reportId={reportId}
      deviceId={deviceId}
      handleClose={() => onClose(type)}
    />
  );
}

/**
 * Renders the modals for the types a screen was given. Each type brings its own component, so a
 * screen can only open the forms in its own list — the commissioning modals are not reachable
 * from the audits screen, and vice versa.
 */
export default function ReportModals ({ types, ...rest }: SelectionProps & { types: FieldReportTypeDef[] }) {
  return (
    <>
      {types.map(({ value, Modal }) => (
        <ReportModal key={value} type={value} Modal={Modal} {...rest} />
      ))}
    </>
  );
}
